<template>
  <el-col :span="8" class="statistic-graph">
    <el-card class="data" v-loading="loading_tracks">
      <div class="card-header" slot="header">
        <div class="card-header__title">
          <img class="report-img" src="@/assets/images/tracks.svg" alt="" />
          <span>TRACK TOTAL</span>
        </div>
        <div class="card-header__total">
          <div>Total: {{ total }}</div>
        </div>
      </div>

        <GChart
          class="chart"
          type="ColumnChart"
          :data="tracks_chart"
          :options="TrackChartSet"
          v-if="tracks_chart.length > 1"
        />

        <div v-else class="no-data"><span>No Data</span></div>

    </el-card>
  </el-col>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import { GChart } from 'vue-google-charts'
export default {
  components: {
    GChart
  },

  computed: {
    ...mapState('adminDashboard', [
      'TrackChartSet',
      'loading_tracks',
      'tracks'
    ]),
    ...mapGetters('adminDashboard', ['tracks_chart']),

    total() {
      let total = 0
      this.tracks.forEach(item => {
        total+= item.active + item.inactive
      })
      return this.commaNum(total, 0)
    }
  },

  data() {
    return {
      selectedCommand: 'Date range',
      colors: [
        '#D40C41',
        '#F2F1F1'
      ]
    }
  },

  methods: {
    ...mapActions('adminDashboard', ['readTracksData'])
  }
}
</script>
